var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.363 37.7H39.6c1.299 0 2.376-1.088 2.376-2.4a2.378 2.378 0 0 0-2.376-2.368H22.363a2.378 2.378 0 0 0-2.376 2.368c0 1.312 1.077 2.4 2.376 2.4zm10.71-15.203h-10.71c-1.299 0-2.376 1.088-2.376 2.4a2.378 2.378 0 0 0 2.376 2.368h10.71a2.378 2.378 0 0 0 2.376-2.368c0-1.312-1.078-2.4-2.377-2.4zm22.609-.015c.744-.009 1.555-.018 2.292-.018.792 0 1.426.64 1.426 1.44v25.728C59.4 57.568 53.032 64 45.174 64h-25.22C11.717 64 5 57.248 5 48.928V14.432C5 6.496 11.4 0 19.29 0h16.918a1.46 1.46 0 0 1 1.457 1.472v10.304c0 5.856 4.785 10.656 10.583 10.688 1.354 0 2.548.01 3.593.019.813.007 1.535.013 2.173.013.45 0 1.035-.007 1.668-.014zm.871-4.67c-2.604.009-5.674 0-7.883-.023-3.504 0-6.39-2.915-6.39-6.455V2.9c0-1.379 1.657-2.064 2.604-1.069l6.418 6.741 6.338 6.658c.925.97.247 2.579-1.087 2.582z",
    fill: "url(#dxs7nu8dca)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 56.569c-1.425 0-2.54-.42-3.342-1.262-.798-.84-1.197-2.014-1.197-3.521 0-1.498.399-2.668 1.197-3.509.803-.845 1.891-1.268 3.266-1.268.87 0 1.628.175 2.273.525.644.346 1.14.848 1.485 1.505.158.29.237.576.237.858 0 .299-.094.54-.282.724-.187.179-.435.268-.742.268-.26 0-.476-.055-.647-.166-.17-.115-.32-.301-.448-.557-.414-.85-1.031-1.274-1.85-1.274-.645 0-1.155.258-1.53.774-.377.517-.564 1.221-.564 2.113 0 .905.187 1.616.563 2.133.376.516.888.774 1.537.774.858 0 1.48-.427 1.87-1.28.123-.252.262-.434.416-.544.157-.111.36-.167.608-.167.333 0 .6.096.8.288.2.188.301.438.301.75 0 .221-.049.448-.147.678-.278.657-.76 1.182-1.447 1.575-.687.389-1.473.583-2.356.583z",
    fill: "url(#8xnkr1wu7b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.31 56.569c-.955 0-1.743-.158-2.362-.474-.619-.32-1.03-.732-1.236-1.236a1.456 1.456 0 0 1-.121-.583c0-.294.094-.53.282-.71.192-.184.437-.276.736-.276.23 0 .427.047.589.141.166.094.324.254.474.48.299.547.858.82 1.677.82.453 0 .818-.09 1.095-.269.278-.183.416-.418.416-.704a.682.682 0 0 0-.333-.602c-.221-.15-.606-.277-1.152-.384l-.954-.18c-.922-.174-1.62-.484-2.094-.928-.47-.448-.704-1.024-.704-1.729 0-.879.341-1.585 1.024-2.119.688-.538 1.569-.807 2.645-.807.883 0 1.632.163 2.247.487.619.324 1.04.779 1.261 1.364.065.162.097.33.097.505a.848.848 0 0 1-.276.66c-.18.166-.416.252-.71.256-.257 0-.472-.049-.647-.147-.171-.098-.325-.26-.461-.487-.278-.533-.775-.8-1.492-.8-.418 0-.75.085-.993.256a.79.79 0 0 0-.358.672c0 .244.11.438.333.583.222.145.585.267 1.088.365l.948.18c.99.187 1.716.492 2.177.915.46.418.691.99.691 1.716 0 .935-.345 1.675-1.037 2.222-.691.542-1.641.813-2.85.813z",
    fill: "url(#oin8s06obc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.038 56.55c-.482 0-.875-.114-1.178-.34-.299-.226-.538-.589-.717-1.088l-2.293-6.3a1.997 1.997 0 0 1-.108-.66c0-.337.113-.61.339-.82.23-.209.531-.313.903-.313.324 0 .585.076.781.23.196.15.341.386.435.71l1.87 6.141h.051l1.85-6.172c.09-.312.229-.54.417-.685.188-.15.44-.224.755-.224.359 0 .65.102.871.307.226.2.34.463.34.787 0 .21-.039.417-.116.622l-2.311 6.377c-.175.495-.414.858-.717 1.088-.303.226-.694.34-1.172.34z",
    fill: "url(#kn46mwxend)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dxs7nu8dca",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8xnkr1wu7b",
    x1: 19.961,
    y1: 47.009,
    x2: 19.961,
    y2: 56.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oin8s06obc",
    x1: 19.961,
    y1: 47.009,
    x2: 19.961,
    y2: 56.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kn46mwxend",
    x1: 19.961,
    y1: 47.009,
    x2: 19.961,
    y2: 56.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.b59d7df4ec9d1f0d78762d11acf460c9.svg";
export { ForwardRef as ReactComponent };